<template>
  <div>Redirecting...</div>
</template>
<script>
export default {
  name: 'RedirectView',
  created () {  window.top.location.href = this.$route.query.closeurl }
}
</script>
